import { useState } from 'react';

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      name: 'Ibu Siti Aminah',
      role: 'Pemilik Warung Makan',
      image: 'https://public.readdy.ai/ai/img_res/7eaa78ecfd16b7a61ab6a09718ce8f59.jpg',
      rating: 5,
      text: 'Sangat puas dengan layanan cetak stiker menu dan desain banner untuk warung saya. Hasilnya bagus dan harganya terjangkau. Pelayanannya juga ramah dan cepat!',
      service: 'Desain & Percetakan'
    },
    {
      name: 'Bapak Ahmad Fauzi',
      role: 'Pengurus Masjid Al-Ikhlas',
      image: 'https://readdy.ai/api/search-image?query=indonesian%20man%20mosque%20administrator%20wearing%20peci%20traditional%20cap%20smiling%20kindly%20in%20front%20of%20mosque%20building%20warm%20expression%20natural%20daylight%20authentic%20portrait&width=120&height=120&seq=test2&orientation=squarish',
      rating: 5,
      text: 'Alhamdulillah, jam digital masjid yang dipasang sangat membantu jamaah. Jadwal sholat otomatis update dan tampilannya jelas. Teknisinya profesional dan sabar menjelaskan cara penggunaannya.',
      service: 'Jam Digital Masjid'
    },
    {
      name: 'Dinda Putri',
      role: 'Mahasiswa',
      image: 'https://readdy.ai/api/search-image?query=young%20indonesian%20female%20college%20student%20smiling%20cheerfully%20wearing%20casual%20modern%20clothes%20holding%20laptop%20friendly%20expression%20natural%20lighting%20authentic%20portrait&width=120&height=120&seq=test3&orientation=squarish',
      rating: 5,
      text: 'Laptop saya yang lemot dan sering error sekarang sudah lancar lagi setelah diinstall ulang dan upgrade SSD. Pengecekan gratis dan garansinya juga bikin tenang. Recommended!',
      service: 'Servis Laptop'
    },
    {
      name: 'Pak Budi Santoso',
      role: 'Pemilik Toko Kelontong',
      image: 'https://readdy.ai/api/search-image?query=middle%20aged%20indonesian%20man%20shop%20owner%20smiling%20confidently%20in%20front%20of%20small%20grocery%20store%20wearing%20casual%20shirt%20friendly%20expression%20natural%20daylight%20authentic%20portrait&width=120&height=120&seq=test4&orientation=squarish',
      rating: 5,
      text: 'Pasang CCTV 4 kamera untuk toko, hasilnya jernih dan bisa dipantau lewat HP. Harga paket lengkap dengan pemasangan sangat worth it. Terima kasih Bastian Digital Service!',
      service: 'Pemasangan CCTV'
    },
    {
      name: 'Rina & Andi',
      role: 'Pasangan Pengantin',
      image: 'https://readdy.ai/api/search-image?query=young%20indonesian%20couple%20bride%20and%20groom%20smiling%20happily%20together%20in%20wedding%20attire%20elegant%20portrait%20joyful%20expression%20natural%20lighting%20authentic%20photo&width=120&height=120&seq=test5&orientation=squarish',
      rating: 5,
      text: 'Undangan digital website untuk pernikahan kami sangat cantik dan mudah dibagikan ke tamu. Fitur RSVP dan peta lokasi sangat membantu. Harga terjangkau dengan hasil maksimal!',
      service: 'Undangan Digital'
    },
    {
      name: 'Ibu Nur Hidayah',
      role: 'Ibu Rumah Tangga',
      image: 'https://readdy.ai/api/search-image?query=indonesian%20housewife%20mother%20smiling%20warmly%20wearing%20hijab%20in%20home%20setting%20friendly%20expression%20natural%20lighting%20authentic%20portrait&width=120&height=120&seq=test6&orientation=squarish',
      rating: 5,
      text: 'Cetak foto keluarga dan foto kenangan lama yang sudah rusak bisa diperbaiki dengan bagus. Pelayanannya ramah dan hasilnya memuaskan. Pasti akan kembali lagi!',
      service: 'Cetak & Restorasi Foto'
    }
  ];

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-[#FF8A00] font-semibold text-sm uppercase tracking-wider bg-orange-50 px-4 py-2 rounded-full">
              Testimoni
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B1F3B] mb-4">
            Apa Kata Pelanggan Kami
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Kepuasan pelanggan adalah prioritas utama kami
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="relative bg-white rounded-3xl shadow-2xl p-8 md:p-12 border border-gray-100">
            <div className="absolute top-8 left-8 text-[#FF8A00] opacity-20">
              <i className="ri-double-quotes-l text-6xl"></i>
            </div>

            <div className="relative z-10">
              <div className="flex flex-col md:flex-row items-center gap-8 mb-8">
                <img
                  src={testimonials[activeIndex].image}
                  alt={testimonials[activeIndex].name}
                  className="w-24 h-24 rounded-full object-cover border-4 border-[#FF8A00] shadow-lg"
                />
                <div className="text-center md:text-left">
                  <h3 className="text-2xl font-bold text-[#0B1F3B] mb-1">
                    {testimonials[activeIndex].name}
                  </h3>
                  <p className="text-gray-600 mb-2">{testimonials[activeIndex].role}</p>
                  <div className="flex gap-1 justify-center md:justify-start">
                    {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-[#FF8A00] text-lg"></i>
                    ))}
                  </div>
                </div>
              </div>

              <p className="text-gray-700 text-lg leading-relaxed mb-6 italic">
                "{testimonials[activeIndex].text}"
              </p>

              <div className="inline-block bg-gradient-to-r from-[#0B1F3B] to-[#0d2847] text-white px-4 py-2 rounded-full text-sm font-semibold">
                <i className="ri-service-line mr-2"></i>
                {testimonials[activeIndex].service}
              </div>
            </div>

            <div className="absolute bottom-8 right-8 text-[#FF8A00] opacity-20">
              <i className="ri-double-quotes-r text-6xl"></i>
            </div>
          </div>

          <div className="flex items-center justify-center gap-4 mt-8">
            <button
              onClick={prevTestimonial}
              className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-[#0B1F3B] hover:text-white transition-all duration-300 border border-gray-200 cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-2xl"></i>
            </button>

            <div className="flex gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                    index === activeIndex ? 'w-8 bg-[#FF8A00]' : 'w-2 bg-gray-300'
                  }`}
                />
              ))}
            </div>

            <button
              onClick={nextTestimonial}
              className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-[#0B1F3B] hover:text-white transition-all duration-300 border border-gray-200 cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-2xl"></i>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16 max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl p-6 shadow-lg text-center border border-gray-100">
            <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#FF8A00] to-orange-600 rounded-full mx-auto mb-4">
              <i className="ri-user-smile-line text-3xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-[#0B1F3B] mb-2">500+</h3>
            <p className="text-gray-600">Pelanggan Puas</p>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-lg text-center border border-gray-100">
            <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#0B1F3B] to-blue-900 rounded-full mx-auto mb-4">
              <i className="ri-star-line text-3xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-[#0B1F3B] mb-2">4.9/5</h3>
            <p className="text-gray-600">Rating Pelanggan</p>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-lg text-center border border-gray-100">
            <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-green-500 to-green-600 rounded-full mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-[#0B1F3B] mb-2">100%</h3>
            <p className="text-gray-600">Garansi Kepuasan</p>
          </div>
        </div>
      </div>
    </section>
  );
}
